export const envConfig = {
  supbaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supbaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  googleOAuthRedirectTo: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_TO,
};
